import { useState, useRef, useEffect } from "react";
import fetchData from "../../../shared/fetchData";
import { checkValidity, updateObject } from "../../../shared/utility";
import ContentForm from "../../UI/ContentForm/ContentForm";
import Input from "../../UI/Input/Input";
import Button from "../../UI/Button/Button";
import VideoInput from "../../UI/Video/Video";
import Modal from "../../UI/Modal/Modal";
import SelectBox from "../../UI/Select/Select";
import "../ClientVideo.css";
import Spinner from "../../UI/Spinner/Spinner";

const ClientVideoForm = (props) => {

    const [file, setFile] = useState([]);
    const [loading, setLoading] = useState(false);
    const [rerender, setRerender] = useState(false);
    const [isGlobal, setIsGlobal] = useState(false);
    const [bunches, setBunches] = useState([]);
    const [selectedBunch, setSelectedBunch] = useState("");
    const [bunchKiosks, setBunchKiosks] = useState([]);
    const [selectedKiosks, setSelectedKiosks] = useState([]);
    const [kioskSelectionError, setKioskSelectionError] = useState(false);
    const [video, setVideo] = useState({
        videoName: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'شرح ویدئو'
            },
            validation: {
                required: true
            },
            errorMessage: 'الزامی است',
            valid: true,
            value: ''
        },
        order: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'شماره پخش'
            },
            validation: {
                required: true
            },
            errorMessage: 'الزامی است',
            valid: true,
            value: ''
        },
    })
    const ref = useRef();

    useEffect(() => {
        var raw = JSON.stringify({ pl: "10000", pn: "1", version: "mtpx001" });
        var url = "management/api/v1/bunches/getBunches";
        fetchData(raw, url)
            .then((response) => response.json())
            .then((result) => {
                if (result.status == 0) {
                    setBunches(result.bunches || []);
                }
            })
            .catch((error) => console.log(error));
    }, []);

    const inputChangedHandler = (event, controlName) => {
        const updatedControls = updateObject(video, {
            [controlName]: updateObject(video[controlName], {
                value: event.target.value,
                valid: !!event.target.value ? true : false
            })
        });
        setVideo(updatedControls)
    }
    const toBase64 = (file) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    })
    const setSource = async (event, url) => {
        let fileTypeStr = event.target.files[0].name.split('.')
        let fileType = ''
        if (fileTypeStr.length !== 0)
            fileType = fileTypeStr[1]
        const fls = new Array;
        const file = event.target.files[0]
        const base64File = await toBase64(file)
        fls.push({
            downloadUrl: base64File,
            fileType: fileType,
        });
        setFile(fls);
    }

    const isGlobalChangeHandler = (event) => {
        const checked = event.target.checked;
        setIsGlobal(checked);
        if (checked) {
            setKioskSelectionError(false);
        }
    }

    const bunchChangeHandler = (value) => {
        setSelectedBunch(value);
        if (!!value) {
            const bunch = bunches.find((b) => b.id === value.value);
            setBunchKiosks(bunch?.kiosks || []);
        } else {
            setBunchKiosks([]);
        }
    }

    const isKioskSelected = (kioskId) => {
        return selectedKiosks.some((k) => k.id === kioskId);
    }

    const chooseKiosk = (kiosk) => {
        if (isKioskSelected(kiosk.id)) {
            setSelectedKiosks(selectedKiosks.filter((k) => k.id !== kiosk.id));
        } else {
            setSelectedKiosks([
                ...selectedKiosks,
                {
                    id: kiosk.id,
                    description: kiosk.description,
                    bunchId: selectedBunch.value,
                    bunchName: selectedBunch.label,
                },
            ]);
        }
        setKioskSelectionError(false);
        setRerender(!rerender);
    }

    const removeSelectedKiosk = (kioskId) => {
        setSelectedKiosks(selectedKiosks.filter((k) => k.id !== kioskId));
        setKioskSelectionError(false);
    }

    const clearAllSelectedKiosks = () => {
        setSelectedKiosks([]);
        setKioskSelectionError(false);
    }

    const submitForm = () => {
        setLoading(true);
        let valid = true;
        const info = video
        if (file == null || file.length == 0) {
            valid = false;
            ref.current.openModal();
        }
        for (let key in info) {
            if (!checkValidity(info[key].value, info[key].validation)) {
                info[key].valid = false
                valid = false
            }
        }
        if (!isGlobal && selectedKiosks.length === 0) {
            valid = false;
            setKioskSelectionError(true);
        }
        if (!valid) {
            setLoading(false);
            setVideo(info);
            setRerender(!rerender);
        } else {
            const kioskIds = selectedKiosks.map((k) => k.id);
            var raw = JSON.stringify({
                video: {
                    downloadUrl: file[0].downloadUrl,
                    fileType: file[0].fileType,
                    videoName: video.videoName.value,
                    order: video.order.value,
                    isGlobal: isGlobal,
                    kioskIds: isGlobal ? [] : kioskIds,
                },
                "version": "mtpx001"
            })
            var url = 'management/api/v1/clientvideos/insertClientVideo'
            fetchData(raw, url).then(response => response.json())
                .then(result => {
                    setLoading(false)
                    if (result.status == '0') {
                        props.toggleNewLockerForm();
                    }
                })
                .catch(error =>
                    setLoading(false))
        }
    }
    const afterCloseModal = () => {

    }

    const formElementsArray = [];
    for (let key in video) {
        formElementsArray.push({
            id: key,
            config: video[key]
        })
    }
    let form = formElementsArray.map(formElement => {
        let col = '4 mt-2'
        return (
            <Input
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                placeholder={formElement.config.placeholder}
                errorMessage={formElement.config.errorMessage}
                search={true}
                col={col}
                changed={(event) => inputChangedHandler(event, formElement.id)} />
        )
    })

    let bunchList = [];
    if (bunches != null && bunches.length !== 0) {
        bunches.map((b) => {
            bunchList.push({
                value: b.id,
                label: b.description,
            });
        });
    }

    const selectedKioskChips = selectedKiosks.map((kiosk) => (
        <div key={kiosk.id} className="video-kiosk-chip">
            <div className="video-kiosk-chip-content">
                <span className="video-kiosk-chip-name">{kiosk.description}</span>
                <span className="video-kiosk-chip-bunch">{kiosk.bunchName}</span>
            </div>
            <button
                type="button"
                className="video-kiosk-chip-remove"
                onClick={() => removeSelectedKiosk(kiosk.id)}
                title="حذف"
            >
                ×
            </button>
        </div>
    ));

    const kioskPickerItems = bunchKiosks.map((kiosk) => {
        const selected = isKioskSelected(kiosk.id);
        return (
            <div
                key={kiosk.id}
                className={`video-kiosk-picker-item ${selected ? 'video-kiosk-picker-item-selected' : ''}`}
                onClick={() => chooseKiosk(kiosk)}
            >
                <div className="video-kiosk-picker-check">
                    {selected ? '✓' : ''}
                </div>
                <div className="video-kiosk-picker-info">
                    <div className="video-kiosk-picker-name">{kiosk.description}</div>
                    {kiosk.address ?
                        <div className="video-kiosk-picker-address">{kiosk.address}</div>
                        : ''}
                </div>
            </div>
        );
    });

    return (
        <div className='row justify-content-center'>
            {loading ? <Spinner /> : ''}
            <div className='video-cntnr'>
                <ContentForm headetText='اطلاعات ویدئو'>
                    <div className='row justify-content-center w-100 m-0 mt-3'>
                        <div className='video-frm'>
                            <VideoInput setSource={setSource} width={400} height={300} />
                            <div className='row justify-content-center m-0 w-100 mt-3'>
                                {form}
                            </div>

                            <div className="video-target-section">
                                <div className="video-section-title">محدوده نمایش ویدئو</div>

                                <div className={`video-global-card ${isGlobal ? 'video-global-card-active' : ''}`}>
                                    <label className="video-global-checkbox-simple">
                                        <input
                                            type="checkbox"
                                            className="video-global-checkbox-simple-input"
                                            onChange={isGlobalChangeHandler}
                                            checked={isGlobal}
                                        />
                                        <span className="video-global-checkbox-simple-text">
                                            نمایش روی همه ی لاکر ها
                                        </span>
                                    </label>
                                    <div className="video-global-checkbox-simple-hint">
                                        با انتخاب این گزینه، این ویدئو روی همه لاکرها نمایش داده می‌شود.
                                    </div>
                                </div>

                                {!isGlobal ?
                                    <div className="video-kiosk-target-panel">
                                        <div className="video-selected-panel">
                                            <div className="video-selected-panel-header">
                                                <div>
                                                    <span className="video-selected-panel-title">لاکرهای انتخاب‌شده</span>
                                                    <span className="video-selected-count">{selectedKiosks.length} مورد</span>
                                                </div>
                                                {selectedKiosks.length > 0 ?
                                                    <button
                                                        type="button"
                                                        className="video-clear-all-btn"
                                                        onClick={clearAllSelectedKiosks}
                                                    >
                                                        پاک کردن همه
                                                    </button>
                                                    : ''}
                                            </div>
                                            <div className="video-selected-panel-body">
                                                {selectedKiosks.length > 0 ?
                                                    <div className="video-kiosk-chips">
                                                        {selectedKioskChips}
                                                    </div>
                                                    :
                                                    <div className="video-selected-empty">
                                                        هنوز لاکری انتخاب نشده است. از بخش پایین، خوشه و لاکر مورد نظر را اضافه کنید.
                                                    </div>
                                                }
                                            </div>
                                        </div>

                                        <div className="video-picker-panel">
                                            <div className="video-picker-step">
                                                <span className="video-picker-step-number">۱</span>
                                                <span className="video-picker-step-label">انتخاب خوشه</span>
                                            </div>
                                            <SelectBox
                                                name="video-bunch-select"
                                                value={selectedBunch}
                                                placeholder="خوشه مورد نظر را انتخاب کنید"
                                                options={bunchList}
                                                onChange={bunchChangeHandler}
                                                col="12"
                                            />

                                            {!!selectedBunch ?
                                                <>
                                                    <div className="video-picker-step video-picker-step-second">
                                                        <span className="video-picker-step-number">۲</span>
                                                        <span className="video-picker-step-label">
                                                            انتخاب لاکر از خوشه «{selectedBunch.label}»
                                                        </span>
                                                    </div>
                                                    {bunchKiosks.length > 0 ?
                                                        <div className="video-kiosk-picker-list">
                                                            {kioskPickerItems}
                                                        </div>
                                                        :
                                                        <div className="video-kiosk-empty">
                                                            لاکری برای این خوشه یافت نشد.
                                                        </div>
                                                    }
                                                </>
                                                :
                                                <div className="video-picker-hint">
                                                    برای افزودن لاکر، ابتدا یک خوشه را انتخاب کنید.
                                                </div>
                                            }
                                        </div>

                                        {kioskSelectionError ?
                                            <div className="video-kiosk-error">
                                                لطفا حداقل یک لاکر انتخاب کنید یا گزینه «نمایش روی همه لاکرها» را فعال کنید.
                                            </div>
                                            : ''}
                                    </div>
                                    : ''}
                            </div>

                            <div className='row justify-content-center m-0 w-100 mt-4 video-form-actions'>
                                <div className="col-4">
                                    <Button btnType="Success" clicked={submitForm} >ثبت</Button>
                                </div>
                                <div className="col-4">
                                    <Button btnType="General" clicked={props.back} >برگشت</Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </ContentForm>

            </div>
            <Modal
                content={<div className="row justify-content-center">لطفا فایل را بارگذاری کنید!</div>}
                ref={ref}
                closePermission="true"
                closeModal={(event) => afterCloseModal(event)}
            />
        </div>
    )
}

export default ClientVideoForm;
